import SmartBanner from "./smart-banner-lib";

export const useSmartBanner = () => {
    const smartbanner = new SmartBanner();
    if (document.getElementsByClassName("js_smartbanner").length) {
        smartbanner.publish();
    }
};
